module.exports = __webpack_public_path__ + "img/become_organizer_bg1_mobile.4655229e.jpg";